export default __webpack_public_path__ + "static/media/06_porost-k-tezbe.f2c0dc59.jpg";